import React from "react";
import { demoIntel } from "../Utils/demoIntel";
import "../../assets/intel.css";

// Simulated data for the bio

const IntelTab = ({ intel, playerBaseline }) => {
  return (
    <div className="intel-tab">
      {(demoIntel[playerBaseline?.player_id] || intel).map((item, index) => (
        <div className="intel-item" key={index}>
          <img src={item.image} alt={item.title} className="intel-image" />
          <div className="intel-content">
            <h3 className="intel-title">{item.title}</h3>
            <p className="intel-description">{item.content}</p>
            <div className="intel-metadata">
              <span>{item.source}</span>
              <span className="intel-metadata-separator">/</span>
              <span>{item.date}</span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default IntelTab;
